import React from 'react';
import { Edit } from 'lucide-react';

const StudentTable = ({ students, onEdit }) => {
    return (
        <div className="table-container">
            <table className="students-table">
                <thead>
                    <tr>
                        <th>Name</th>
                        <th>Email</th>
                        <th>Contact</th>
                        <th>Address</th>
                        <th>Date Of Birth</th>
                        <th>Educational Level</th>
                        <th>Educational Course</th>
                        <th>Department</th>
                        <th>Passed Out</th>
                        <th>Course Type</th>
                        <th>Course</th>
                        <th>Status</th>
                        <th>class Type</th>
                        <th>Batch</th>
                        <th>Learning Mode</th>
                        <th>Branch</th>
                        <th>Source</th>
                        <th>Admin Name</th>
                        <th>student Requirement</th>
                        <th>Registered On</th>
                        <th>Enrollment Status</th>
                        <th>Follow Up Date</th>
                        <th>Admin Feedback</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {students.length > 0 ? (
                        students.map((student, index) => (
                            <tr key={index}>
                                <td>{student.name || '-'}</td>
                                <td>{student.email_Id || '-'}</td>
                                <td>{student.contactNo || '-'}</td>
                                <td>{student.address || '-'}</td>
                                <td>{student.dob || '-'}</td>
                                <td>{student.educationLevel || '-'}</td>
                                <td>{student.educationCourse || '-'}</td>
                                <td>{student.department || '-'}</td>
                                <td>{student.passedout || '-'}</td>
                                <td>{student.courseType || '-'}</td>
                                <td>{student.course || '-'}</td>
                                <td>{student.studentStatus || '-'}</td>
                                <td>{student.classType || '-'}</td>
                                <td>{student.batch || '-'}</td>
                                <td>{student.learningMode || '-'}</td>
                                <td>{student.branch || '-'}</td>
                                <td>{student.source || '-'}</td>
                                <td>{student.adminName || '-'}</td>
                                <td>{student.studentRequirement || '-'}</td>
                                <td>{student.createdAt ? new Date(student.createdAt).toISOString().split('T')[0] : '-'}</td>
                                <td>{student.enrollment_status || '-'}</td>
                                <td>{student.follow_up || '-'}</td>
                                <td>{student.admin_feedback || '-'}</td>
                                <td>
                                    <button
                                        className="edit-button"
                                        onClick={() => onEdit(student)}
                                    >
                                        <Edit size={16} />
                                        <span>Edit</span>
                                    </button>
                                </td>
                            </tr>
                        ))
                    ) : (
                        <tr>
                            <td colSpan="23" className="no-results">No students found</td>
                        </tr>
                    )}
                </tbody>
            </table>
        </div>
    );
};

export default StudentTable;